/**
 * TODO: describe function
 * @author Kevin Parkinson
 * @param tags (any[])
*/
export const simplifyContentfulTagsAny = (tags: any[]): string[] => tags.map((item) => (item && item.fields && item.fields.tag ? item.fields.tag : ''));
